import { useContext } from "react"
import { ScrollPositionContext } from "./ScrollPositionContext"
import type { ScrollPositionContextValue } from "./ScrollPositionContextValue"

export function useScrollPositionContext(): ScrollPositionContextValue {
  return useContext(ScrollPositionContext)
}
